module.exports = __webpack_public_path__ + "img/474.5b6aff88.jpg";